import Vue from 'vue'
/* 项目中用到的组件请在这里引入 */
import {
  Button,
  Row,
  Col,
  Pagination,
  Dialog,
  Input,
  Radio,
  Form,
  FormItem,
  MessageBox,
  Message,
  Loading,
  Carousel,
  CarouselItem
} from 'element-ui'
Vue.use(Button)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(Radio)
Vue.use(Row)
Vue.use(Col)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$message = Message
